/**
 * Created by aaron on 2018/1/16.
 */
import appStore from './store';

import versionStore from '@/components/version/store';
import componentInvoiceFormStore from '@/components/invoice-form/store';

// user
import registerStore from '@/pages/user/register/store';

// 首页
import homeStore from '@/pages/home/store';

// 发票中心
import manualStore from '@/pages/invoice-center/manual-invoice/store';
import addInvoiceStore from '@/pages/invoice-center/add-invoice/store';
import recordsStore from '@/pages/invoice-center/records/store';
import smallticketStore from '@/pages/invoice-center/small-ticket/store';
import printStore from '@/pages/invoice-center/small-ticket/print-store';
import paperInvoiceStore from '@/pages/invoice-center/paper-invoice-manage/store';
import batchInvoiceStore from '@/pages/invoice-center/batch-invoice/store';
import applyStore from '@/pages/invoice-center/invoice-apply/store';

// 管理中心
import codeStore from '@/pages/manage-center/code-manage/store';
import accountStore from '@/pages/manage-center/account-manage/store';
import shopStore from '@/pages/manage-center/shop-manage/store';
import taxStore from '@/pages/manage-center/tax-disc/store';
import sysStore from '@/pages/manage-center/sys-setup/store';

// 收款中心
import receiptStore from '@/pages/receipt-center/store';
import billStore from '@/pages/receipt-center/bill/store';


export default {
    appStore,
    codeStore,
    accountStore,
    sysStore,
    shopStore,
    manualStore,
    recordsStore,
    smallticketStore,
    versionStore,
    addInvoiceStore,
    homeStore,
    printStore,
    taxStore,
    applyStore,
    componentInvoiceFormStore,
    paperInvoiceStore,
    registerStore,
    batchInvoiceStore,
    receiptStore,
    billStore
}
